import { Injectable, inject } from '@angular/core';
import { ServiceConditionStore } from '../stores/service-conditions.store';

@Injectable({
  providedIn: 'root',
})
export class ServiceConditionService {
  private readonly store = inject(ServiceConditionStore);

  readonly notifications = this.store.notifications;
  readonly isBannerVisible = this.store.isBannerVisible;
  readonly loading = this.store.loading;

  loadBannerNotifications() {
    this.store.loadBannerNotifications();
  }

  dismissBannerNotification(payload: any) {
    return this.store.dismissBannerNotification(payload);
  }

  acceptServiceCondition(payload: any) {
    return this.store.acceptServiceCondition(payload);
  }
}
